var map = {
	"./BlogHighPerformanceWebsite.js": 8323,
	"./BlogSmallBusinessWebsiteNZ.js": 9222,
	"./a-quick-guide-to-converting-phone-enquiries-into-on-site-leads.js": 6722,
	"./about-page-that-builds-trust-what-to-include-and-what-to-skip.js": 9333,
	"./accessibility-essentials-10-easy-fixes-that-help-real-customers.js": 8254,
	"./add-a-service-area-map-without-slowing-the-page.js": 613,
	"./basic-analytics-track-calls-form-submits-and-email-clicks-in-ga4.js": 2132,
	"./builders--renovators-showcasing-projects-without-confusing-visitors.js": 183,
	"./cleaning-services-quote-forms-that-filter-time-wasters.js": 7176,
	"./click-to-call-and-tap-to-text-set-up-the-two-fastest-ctas.js": 4024,
	"./cookies-banners-do-you-need-one-for-a-small-service-site.js": 8441,
	"./ctas-that-get-enquiries-buttons-phrases-and-placement.js": 5853,
	"./diy-website-audit-20-minute-checklist-for-busy-owners.js": 6344,
	"./do-you-need-a-blog-when-a-5-page-site-is-enough.js": 4070,
	"./driving-instructors-local-seo-for-suburb-specific-bookings.js": 8230,
	"./faq-pages-that-cut-phone-time-and-increase-conversions.js": 5596,
	"./fixing-a-traffic-drop-a-simple-non-technical-diagnostic.js": 2640,
	"./from-zero-to-first-leads-launch-checklist-for-new-sites.js": 7019,
	"./google-business-profile-setup-for-lead-focused-websites.js": 8062,
	"./gyms--pts-class-timetables-and-trials-without-complex-software.js": 277,
	"./homepage-essentials-for-lead-generation-what-to-put-above-the-fold.js": 6919,
	"./homepage-hero-images-choosing-the-right-photo-vs-illustration.js": 2010,
	"./hosting-for-small-sites-what-good-enough-looks-like-in-2025.js": 7322,
	"./how-to-add-a-simple-projects-page-without-managing-a-blog.js": 6081,
	"./how-to-add-reviews-to-your-website-legally-and-effectively.js": 3160,
	"./how-to-build-trust-fast-badges-associations-and-guarantees.js": 9359,
	"./how-to-choose-a-domain-and-professional-email-for-a-credible-first-impression.js": 2472,
	"./how-to-create-a-basic-careerswere-hiring-page-without-a-portal.js": 8133,
	"./how-to-create-a-digital-front-door-for-your-business-with-a-video-intro-page.js": 1058,
	"./how-to-create-evergreen-blog-content-that-attracts-leads-year-round.js": 3138,
	"./how-to-keep-a-small-website-secure-when-youre-busy-running-the-business.js": 3013,
	"./how-to-keep-your-website-fresh-with-one-update-a-month.js": 8874,
	"./how-to-migrate-from-an-old-site-without-losing-your-google-rankings.js": 1747,
	"./how-to-pick-web-fonts-and-sizes-for-readability-on-phones.js": 6514,
	"./how-to-prepare-content-a-one-hour-owners-checklist-before-build.js": 3495,
	"./image-alt-text-and-file-names-tiny-tasks-real-seo-impact.js": 9511,
	"./it-support--msps-service-tiers-without-confusing-visitors.js": 1906,
	"./landscapers--gardeners-photo-led-pages-that-still-load-fast.js": 4866,
	"./local-seo-basics-for-a-small-static-website.js": 858,
	"./near-me-optimization-for-non-techies.js": 3317,
	"./one-contact-form-that-works-fields-to-keep-and-fields-to-drop.js": 2829,
	"./one-hero-cta-or-two-how-many-is-too-many-on-a-small-site.js": 2448,
	"./painters--decorators-colour-galleries-that-convert-browsers-to-bookings.js": 2385,
	"./physios--chiropractors-simple-booking-widgets-that-dont-break-ux.js": 9135,
	"./plumbers-a-high-converting-website-layout-that-gets-the-phone-ringing.js": 5484,
	"./service-area-pages-how-to-rank-in-nearby-suburbs-without-spam.js": 5856,
	"./should-you-list-prices-a-practical-guide-by-industry.js": 107,
	"./simple-schema-markup-for-small-businesses-without-coding-headaches.js": 6147,
	"./simple-ways-to-show-social-proof-without-social-media-embeds.js": 63,
	"./site-care-plan-the-few-things-to-do-quarterly-to-avoid-emergencies.js": 8106,
	"./small-law-firms-ethical-website-basics-disclaimers-and-contact-prompts.js": 501,
	"./speed-matters-how-to-make-a-simple-site-load-in-under-3-seconds.js": 8437,
	"./stop-form-spam-5-easy-wins-without-annoying-captchas.js": 3887,
	"./thank-you-pages-that-nudge-the-next-step-calls-bookings-quotes.js": 1255,
	"./the-simple-guide-to-favicon-social-share-image-and-open-graph-tags.js": 142,
	"./tradies-writing-short-job-descriptions-your-customers-understand.js": 6163,
	"./turning-customer-emails-and-faqs-into-website-content-fast.js": 3970,
	"./using-a-single-reviews-page-vs-sprinkling-reviews-across-pages.js": 9308,
	"./utm-links-for-beginners-see-which-marketing-actually-brings-leads.js": 8919,
	"./what-to-post-on-tiktok-when-youre-a-service-business-and-good-at-it.js": 6405,
	"./what-to-put-in-your-footer-location-licenses-and-quick-links.js": 7577,
	"./what-to-put-in-your-header-and-footer-for-more-enquiries.js": 1402,
	"./when-to-add-online-booking-or-calendars-and-when-not-to.js": 7707,
	"./when-to-redesign-6-signs-your-simple-site-needs-a-refresh.js": 9107,
	"./why-every-small-business-needs-a-digital-strategy-even-a-simple-one.js": 7259,
	"./why-your-site-doesnt-need-fancy-animations-and-what-to-use-instead.js": 6339,
	"./wordpress-vs-static-builders-vs-custom-choosing-the-low-maintenance-option.js": 4365,
	"./write-copy-that-converts-a-simple-formula-for-service-businesses.js": 5919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4009;